module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_004.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_004.png
// module id = 2351
// module chunks = 5